export class FemurAnalyzerLTConfig {
}
FemurAnalyzerLTConfig.FH_color = 0x63ADF2;
FemurAnalyzerLTConfig.AE_color = 0x63ADF2;
FemurAnalyzerLTConfig.PE_color = 0x63ADF2;
FemurAnalyzerLTConfig.TE_color = 0x63ADF2;
FemurAnalyzerLTConfig.apex_color = 0xFF0000;
FemurAnalyzerLTConfig.FH_TE_Line_color = 0x63ADF2;
FemurAnalyzerLTConfig.AE_PE_Line_color = 0x63ADF2;
FemurAnalyzerLTConfig.PDFALabel_backgroundColor = "rgba(0, 0, 0, 0.6)";
FemurAnalyzerLTConfig.PDFALabel_fontColor = "#ffffff";
//# sourceMappingURL=FemurAnalyzerLTConfig.js.map